import { render, staticRenderFns } from "./PopUpSave.vue?vue&type=template&id=5087ffd3&scoped=true"
import script from "./PopUpSave.vue?vue&type=script&lang=js"
export * from "./PopUpSave.vue?vue&type=script&lang=js"
import style0 from "./PopUpSave.vue?vue&type=style&index=0&id=5087ffd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087ffd3",
  null
  
)

export default component.exports